export const QUESTION_DIFFICULTIES = [
  "QUESTION_DIFFICULTY_EASY",
  "QUESTION_DIFFICULTY_MEDIUM",
  "QUESTION_DIFFICULTY_HARD",
] as const;

export const LEVEL_MODALITIES = [
  "LEVEL_MODALITY_QUIZ",
  "LEVEL_MODALITY_STORY",
  "LEVEL_MODALITY_TREASURE_HUNT",
  "LEVEL_MODALITY_TOWER_CLIMB",
  "LEVEL_MODALITY_MAZE",
  "LEVEL_MODALITY_REWARD",
] as const;

export const UNIT_UNLOCK_MODES = [
  "UNLOCK_MODE_FREE",
  "UNLOCK_MODE_BLOCKED",
] as const;

export const LEVEL_PLAY_FORMATS = [
  "PLAY_FORMAT_SOLO",
  "PLAY_FORMAT_TEAM",
] as const;

/** Story and reward are not played; they must not carry playFormat. */
export function levelOmitsPlayFormat(modality: unknown): boolean {
  return (
    modality === "LEVEL_MODALITY_STORY" ||
    modality === "LEVEL_MODALITY_REWARD"
  );
}

export const PRIZE_AMOUNTS = [
  "PRIZE_AMOUNT_NONE",
  "PRIZE_AMOUNT_LOW",
  "PRIZE_AMOUNT_NORMAL",
  "PRIZE_AMOUNT_HIGH",
  "PRIZE_AMOUNT_VERY_HIGH",
] as const;
